<template>
  <main>
    <div class="cover">
      <img
        src="@/assets/account-avatar.svg"
        class="avatar">
      <h2
        v-if="isLogin"
        class="name">您好，{{ nickName }}</h2>
      <h2
        v-else
        class="name">您好</h2>
    </div>
    <van-cell-group>
      <van-cell
        :to="{name: 'user-info'}"
        title="个人信息管理"
        is-link />
      <van-cell
        :to="{name: 'card'}"
        title="就诊卡管理"
        is-link />
      <van-cell
        :to="{name: 'order'}"
        title="我的订单"
        is-link />
    </van-cell-group>
    <div class="p-3">
      <van-button
        v-if="isLogin"
        size="large"
        @click="handleLogout">退出登录</van-button>
      <van-button
        v-else
        type="primary"
        size="large"
        @click="$router.push({name:'login',query: {redirect: '/account'}})">
        立即登录
      </van-button>
    </div>
  </main>
</template>

<script>
export default {
  name: 'Account',
  data() {
    return {
      nickName: '',
      isLogin: false,
    };
  },
  mounted() {
    this.checkLogin();
  },
  activated() {
    this.checkLogin();
  },
  methods: {
    checkLogin() {
      const authorization = localStorage.getItem('accessToken');
      const nickName = localStorage.getItem('nickName');
      this.isLogin = !!authorization;
      this.nickName = nickName;
    },
    async handleLogout() {
      const accessToken = localStorage.getItem('accessToken');
      const openId = localStorage.getItem('open_id');
      await this.$http.post('/patient-api/webapi/weixin/mp/openid-unbind', {
        access_token: accessToken,
        open_id: openId,
      });
      localStorage.removeItem('accessToken');
      this.$toast('退出成功');
      this.$router.push({ name: 'home' });
    },
  },
};
</script>

<style scoped>
.cover {
  background-image: linear-gradient(70deg, #2196f3, #4fc3f7);
  text-align: center;
  padding: 15px;
  color: #fff;
}

.avatar {
  width: 60px;
  height: 60px;
  border-radius: 100%;
}
</style>
